<template>
  <div class="card-container">
    <div class="c-header-container">
      <div class="c-header">
        WARRANTY EXPIRATION WARNING
      </div>
      <div class="c-date-container">
        <div class="c-date">
          {{ date }}
        </div>
      </div>
    </div>
    <div class="c-number-container">
      <img
        v-if="loading && cardData.count < 1"
        src="@shared/assets/img/general/loading-white.svg"
        class="loading"
        alt="loading"
      >
      <div
        v-else-if="cardData.count === 0"
        class="c-count"
      >
        No system is set to expire
      </div>
      <div
        v-else
        class="c-number"
      >
        {{ cardData.count }}
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import customerMixin from '@shared/mixins/customerMixin';

const currentDate = moment();
const todayFormat = currentDate.format('YYYY-MM-DD');
const sixMonth = currentDate.add(6, 'months').format('YYYY-MM-DD');

export default {
  name: 'WarrantyExpiration',
  mixins: [customerMixin],
  data() {
    return {
      date: 'Next 6 months',
    };
  },
  computed: {
    cardData() {
      let count = 0;
      this.tableData.forEach((t) => {
        const {
          deviceAC,
        } = t;
        deviceAC.forEach((ac) => {
          const {
            warranty,
          } = ac;
          const expiring = moment(warranty).isBetween(todayFormat, sixMonth, 'month', '[]');
          if (expiring) {
            count += 1;
          }
        });
      });
      let countLabel = 'systems set to expire';
      if (count > 1) {
        countLabel = 'system set to expire';
      }
      const data = {
        count,
        countLabel,
      };
      return data;
    },
  },
};
</script>
